module.exports = {
  "gradient-panel": {
    "width": "750",
    "height": "800"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-0f699cc9!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-gradient/index.vue
// module id = 427
// module chunks = 0 1